<template>
  <div class="order-query-page">
    <div class="order-query-container">
      <el-tabs
        v-model="activePlatform"
        @tab-click="handleTabChange"
      >
        <el-tab-pane
          label="京东订单查询"
          name="jd"
        ></el-tab-pane>
        <el-tab-pane
          label="淘宝订单查询"
          name="tb"
        ></el-tab-pane>
      </el-tabs>
      <!-- 搜索框 -->
      <div class="search-header">
        <h2>搜索订单，查询状态</h2>
      </div>
      <div class="search-container">
        <template v-if="activePlatform === 'jd'">
          <el-input
            v-model="jdOrderNumber"
            placeholder="请输入京东订单号"
            clearable
            @keyup.enter.native="handleJdQuery(jdOrderNumber)"
            class="search-input"
          ></el-input>
          <el-button
            type="primary"
            @click="handleJdQuery(jdOrderNumber)"
            :loading="isLoading"
            class="search-button force-visible"
          >

            <span class="button-content">
              {{ isLoading ? '查询中...' : '查询' }}
            </span>
          </el-button>
        </template>
        <template v-else>
          <el-input
            v-model="tbOrderNumber"
            placeholder="请输入淘宝订单号"
            clearable
            @keyup.enter.native="handleTbQuery(tbOrderNumber)"
            class="search-input"
          ></el-input>
          <el-date-picker
            v-model="tbTime"
            type="datetime"
            placeholder="订单下单时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="datetime-picker"
          ></el-date-picker>
          <el-button
            type="primary"
            @click="handleTbQuery(tbOrderNumber)"
            :loading="isLoading"
            class="search-button force-visible"
          >

            <span class="button-content">
              {{ isLoading ? '查询中...' : '查询' }}
            </span>
          </el-button>
        </template>

      </div>

      <!-- 订单列表展示 -->
      <div
        v-if="null !== orders && orders.length > 0"
        class="order-list"
      >
        <div
          v-for="(order, index) in orders"
          :key="index"
          class="order-item"
        >
          <!-- 订单头部信息 -->
          <div class="order-header">
            <div class="order-number">订单号：{{ order.orderId }}</div>
            <div class="order-number">主单号：{{ order.parentId === '0' ? order.orderId : order.parentId }}</div>
            <div
              class="order-number"
              v-if="!order.validCodeMsg.includes('已完成')"
            >实付金额：{{ order.estimateCosPrice }}</div>
            <div
              class="order-number"
              v-if="order.validCodeMsg.includes('已完成')"
            >实际计佣金额：{{ order.actualCosPrice }}</div>
            <div class="order-meta">
              <el-tag size="small">
                {{ order.validCodeMsg }}
              </el-tag>

              <el-tag size="small">
                {{ order.platform }}后台
              </el-tag>

              <el-tag>{{order.activityReturn}}</el-tag>
              <el-tag
                v-if="activePlatform === 'jd'"
                :type="traceTypeMap[order.traceType].type"
              >{{ traceTypeMap[order.traceType].text }}</el-tag>
            </div>
          </div>

          <!-- 商品列表 - 左图右文布局 -->
          <div class="products-container">
            <div class="product-item">
              <div class="product-image-container">
                <img
                  :src="order.goodsInfo.imageUrl"
                  class="product-image"
                />
              </div>
              <div class="product-info">
                <div class="product-name">店铺：{{ order.goodsInfo.shopName }}</div>
                <div class="product-sku">{{ order.skuName }}</div>
                <div class="product-sku">下单时间：{{ order.orderTime }}</div>
                <div class="product-sku">完成时间：{{ order.finishTime }}</div>
                <div class="product-sku">商品数量：{{ order.skuNum }}</div>
                <div class="product-sku">退货数量：{{ order.skuReturnNum }}</div>
                <div class="product-sku">售后中数量：{{ order.skuFrozenNum }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 空状态 -->
      <div
        v-if="(null === orders || orders.length === 0) && searched"
        class="empty-state"
      >
        <el-empty description="未找到相关订单"></el-empty>
      </div>

      <!-- 订单查询须知 -->
      <el-card
        class="rules-card"
        shadow="never"
      >
        <div class="rules-header">订单查询须知</div>
        <div class="rules-content">
          <div class="rule-item">
            <span>1.根据要求下单。（最后是在京东、天猫等平台下单）</span>
          </div>
          <div class="rule-item">
            <span>2.查单系统有延时，请下单3分钟后再查，显示下单信息有具体金额，即为【跟团成功】。下单3～10分钟查询结果仍为“暂无相关订单”即【跟团失败】，请尽快联系负责人。</span>
          </div>
          <div class="rule-item">
            <span>3.跟团成功所有产品均享受【无理由退货且退货包运费】兜底服务</span>
          </div>
          <div class="rule-item">
            <span>4.如订单仅显示赠品/凑单品，不显示主商品为无效订单，需取消重拍。</span>
          </div>
          <div class="rule-item">
            <span>5.如订单状态显示“待付款”“已付款””或“已完成”即为跟团成功，可付款。</span>
          </div>
          <div class="rule-item">
            <span>6.京东可能存在拆单更新订单号的情况，付款后请用京东最新订单号进行查询</span>
          </div>
          <div class="rule-item">
            <span>7.成功跟团后截图保存，并将订单号发送到群内回复跟团成功，以便团长联系。</span>
          </div>
          <div class="rule-item">
            <span>8.付款后订单号可能会更新，请使用最新订单号查询确认。</span>
          </div>
          <div class="rule-item">
            <span>9.下单时请勿使用京东e卡、京豆、礼金、充值卡等或返利软件，会影响额外返现。</span>
          </div>
          <div class="rule-item">
            <span>10.如查询结果显示 【流量异常&违规订单】等特殊情况；未发货订单请退款重新下单，已发货订单联系售后客服特殊处理</span>
          </div>
          <div class="rule-item">
            <span>11.如有疑问，请在团购群内联系团长咨询哦-</span>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getoutsideorder, getoutsidetborder } from "@/api/outsideorder";
export default {
  data() {
    return {
      activePlatform: "jd", // 当前激活的平台 jd/tb
      jdOrderNumber: "",
      tbOrderNumber: "", // 淘宝订单号
      orders: [],
      tbTime: "",
      isLoading: false,
      searched: false,
      traceTypeMap: {
        "2": { type: "success", text: "同店" },
        "3": { type: "danger", text: "跨店" }
      }
    };
  },
  methods: {
    handleTabChange() {
      // 切换平台时清空数据
      this.orders = [];
      this.searched = false;
    },
    async handleJdQuery(val) {
      if (!val.trim()) {
        this.$message.error("订单号必填！");
        return;
      }
      this.isLoading = true;
      this.searched = true;
      try {
        const res = await getoutsideorder({ orderId: val });
        if (res.code == 1000) {
          this.isLoading = false;
          this.orders = res.data;
        } else {
          this.isLoading = false;
          this.orders = null;
          this.$message.error(res.message || "查询失败");
        }
      } catch (error) {
        this.orders = null;
        this.isLoading = false;
        this.$message.error("查询失败: " + error.message);
      } finally {
        this.isLoading = false;
        // 移动端强制重绘
        this.$nextTick(() => {
          const btn = document.querySelector(".search-button");
          if (btn) {
            btn.style.display = "none";
            btn.offsetHeight; // 触发重绘
            btn.style.display = "";
          }
        });
      }
    },
    async handleTbQuery(val) {
      if (!val.trim()) {
        this.$message.error("订单号必填！");
        return;
      }
      if (!this.tbTime.trim()) {
        this.$message.error("请选择下单时间10分钟内的时间");
        return;
      }
      this.isLoading = true;
      this.searched = true;
      try {
        const res = await getoutsidetborder({
          orderId: val,
          payDate: this.tbTime
        });
        if (res.code == 1000) {
          this.isLoading = false;
          this.orders = res.data;
        } else {
          this.isLoading = false;
          this.orders = null;
          this.$message.error(res.message || "查询失败");
        }
      } catch (error) {
        this.orders = null;
        this.isLoading = false;
        this.$message.error("查询失败: " + error.message);
      } finally {
        this.isLoading = false;
        // 移动端强制重绘
        this.$nextTick(() => {
          const btn = document.querySelector(".search-button");
          if (btn) {
            btn.style.display = "none";
            btn.offsetHeight; // 触发重绘
            btn.style.display = "";
          }
        });
      }
    }
  }
};
</script>

<style scoped>
/* 页面容器 */
.order-query-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #f5f5f5;
}

/* 内容容器 */
.order-query-container {
  flex: 1;
  padding: 15px 16px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
  background: #6353bf;
}

.search-header {
  margin-bottom: 30px;
}

.search-header h2 {
  font-size: 18px;
  color: black;
  margin: 0 0 30px 0;
}

/* 搜索区域 */
.search-container {
  display: flex;
  margin-bottom: 15px;
  gap: 10px;
}

.search-input {
  flex: 1;
  min-width: 0;
}

.search-button {
  flex-shrink: 0;
  width: 80px;
}

/* 加载状态样式 */
.search-button.is-loading {
  opacity: 0.8;
  padding-left: 8px; /* 为加载图标留出空间 */
}

/* 鼠标悬停效果 */
.search-button:not(.is-disabled):hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

/* 激活状态 */
.search-button:active {
  transform: translateY(0);
}

/* 订单列表 */
.order-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 15px;
}

.order-item {
  background-color: white;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 8px;
}

.order-number {
  font-weight: bold;
  font-size: 16px;
  color: #333;
}

.order-meta {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

/* 商品列表 */
.products-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.product-item {
  display: flex;
  gap: 12px;
  padding: 8px 0;
  border-top: 1px solid #f0f0f0;
}

.product-item:first-child {
  border-top: none;
}

.product-image-container {
  width: 80px;
  height: 80px;
  flex-shrink: 0;
}

.product-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.product-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.product-name {
  font-size: 15px;
  margin-bottom: 4px;
  word-break: break-word;
}

.product-sku {
  font-size: 13px;
  color: #666;
  word-break: break-word;
}

/* 规则卡片 */
.rules-card {
  margin-top: 15px;
  border-radius: 8px;
  border: none;
  background-color: #fff;
}

.rules-header {
  font-weight: bold;
  margin-bottom: 12px;
  color: #303133;
  font-size: 16px;
}

.rules-content {
  padding: 0 4px;
}

.rule-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  line-height: 1.6;
  font-size: 14px;
}

.rule-item .el-tag {
  margin-right: 8px;
  flex-shrink: 0;
  margin-top: 2px;
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 40px 0;
  color: #999;
  background-color: white;
  border-radius: 8px;
  margin-bottom: 15px;
}

.force-visible {
  position: relative !important;
}

.force-visible .button-content {
  display: inline-block !important;
  visibility: visible !important;
  opacity: 1 !important;
  width: 100% !important;
}

/* 响应式调整 */
@media (max-width: 480px) {
  .force-visible .el-icon-loading {
    display: none !important;
  }

  .force-visible::after {
    content: "" !important;
    display: none !important;
  }

  .order-query-container {
    padding: 15px 12px;
  }

  .search-container {
    flex-direction: column;
  }

  .search-button {
    width: 100%;
  }

  .order-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .product-image-container {
    width: 70px;
    height: 70px;
  }

  .rule-item {
    margin-bottom: 10px;
    font-size: 13px;
  }

  .rules-header {
    font-size: 15px;
  }
}
::v-deep(.el-button:hover) {
  background: #409eff;
}
</style>